module.exports = __webpack_public_path__ + "img/sagume kishin_sc1.ebe4ba04.png";